import React from 'react';
import { Navigate } from 'react-router-dom';
import { UserAuthContext } from '../context/AuthContext';

const ProtectedAdmin = ({ children }) => {
  const { user } = UserAuthContext();

  if (
    user?.email === 'taxreturn@meritsaccounting.ca' ||
    user?.email === 'pedro.bfinkler@gmail.com' ||
    user?.email === 'alexsalesramos@gmail.com' ||
    user?.email === 'victorvhrs@outlook.com' ||
    user?.email === 'ale.osantos.oficial@gmail.com'
  ) {
    return children;
  } else if (user) {
    return <Navigate to="/account" />;
  }
  return <Navigate to="/" />;
};

export default ProtectedAdmin;
